"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonalInfoHeader = PersonalInfoHeader;
exports.PersonalInfoEditForm = PersonalInfoEditForm;
exports.default = PersonalInfoEdit;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const cancelable_promise_1 = require("cancelable-promise");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const ModalWrapper_1 = __importDefault(require("../components/ModalWrapper"));
const Helper_1 = require("../Helper");
const Button_1 = __importDefault(require("../components/Button"));
const UserContext_1 = require("../contexts/UserContext");
const Loading_1 = __importDefault(require("../components/Loading"));
const react_native_mask_text_1 = require("react-native-mask-text");
const MyProfile_1 = __importDefault(require("../api/MyProfile"));
const react_i18next_1 = require("react-i18next");
const FirebaseAnalytics_1 = __importDefault(require("../shared/FirebaseAnalytics"));
const SearchableDropdown_1 = __importDefault(require("../components/SearchableDropdown"));
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const FadeInView_1 = __importDefault(require("../components/FadeInView"));
const createStyles = (THEME, isDark) => react_native_1.StyleSheet.create({
    sectionHeader: {
        marginVertical: 12,
        backgroundColor: isDark
            ? (THEME.SurfaceVariant ?? THEME.CardBackground)
            : (THEME.UltraLightGray ?? THEME.CardBackground),
        borderRadius: 5,
        paddingVertical: 10,
        paddingHorizontal: 12,
        position: "relative",
        borderWidth: 1,
        borderColor: isDark
            ? (THEME.Outline ?? THEME.Surface)
            : (THEME.Surface ?? THEME.Outline ?? THEME.UltraLightGray),
    },
    sectionLeft: { paddingRight: 140 },
    sectionLeftCompact: { paddingRight: 200 },
    sectionTitle: {
        color: THEME.OnSurface ?? THEME.Text,
        fontSize: 12,
        fontWeight: "500",
    },
    sectionHint: {
        color: isDark
            ? (THEME.Text ?? THEME.OnSurface ?? THEME.TextLight)
            : (THEME.Text ?? THEME.OnSurface),
        opacity: isDark ? 0.9 : 0.75,
        fontSize: 11,
        marginTop: 4,
    },
    sameAsHomeAbsolute: {
        position: "absolute",
        right: 12,
        top: 0,
        bottom: 0,
        flexDirection: "row",
        alignItems: "center",
    },
    sameAsHomeText: {
        color: THEME.OnSurface ?? THEME.Text,
        fontSize: 12,
        marginRight: 8,
        includeFontPadding: false,
        textAlignVertical: "center",
    },
    zipFullRow: { marginBottom: 12 },
    sameAsHomeSwitch: {
        alignSelf: "center",
        marginTop: react_native_1.Platform.OS === "web" ? -1 : 0,
        marginBottom: 0,
    },
    disclaimerContainer: {
        flexDirection: "row",
        alignItems: "center",
        backgroundColor: isDark
            ? (THEME.SurfaceVariant ?? THEME.CardBackground)
            : (THEME.UltraLightGray ?? THEME.CardBackground),
        paddingVertical: 8,
        paddingHorizontal: 10,
        borderRadius: 4,
        minHeight: 40,
        borderWidth: 1,
        borderColor: isDark
            ? (THEME.Outline ?? THEME.Surface)
            : (THEME.Surface ?? THEME.Outline ?? THEME.UltraLightGray),
    },
    disclaimerText: {
        color: THEME.TextMuted ?? THEME.Text,
        fontSize: 12,
        flex: 1,
        lineHeight: 16,
    },
});
function Collapsible({ collapsed, children }) {
    const maxHeight = react_1.default.useRef(new react_native_1.Animated.Value(collapsed ? 0 : 2000)).current;
    const opacity = react_1.default.useRef(new react_native_1.Animated.Value(collapsed ? 0 : 1)).current;
    react_1.default.useEffect(() => {
        react_native_1.Animated.timing(maxHeight, {
            toValue: collapsed ? 0 : 2000,
            duration: 400,
            useNativeDriver: false,
        }).start();
        react_native_1.Animated.timing(opacity, {
            toValue: collapsed ? 0 : 1,
            duration: 400,
            useNativeDriver: false,
        }).start();
    }, [collapsed]);
    return ((0, jsx_runtime_1.jsx)(react_native_1.Animated.View, { style: { overflow: "hidden", maxHeight: maxHeight, opacity: opacity }, pointerEvents: collapsed ? "none" : "auto", children: children }));
}
function PersonalInfoHeader(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: "row", justifyContent: "center", alignItems: "center" }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.DuoTone.Pen, size: 20, color: THEME.Secondary }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flex: 1 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontWeight: "500", fontSize: size != 'sm' ? 18 : 16, marginLeft: 12 }, children: props.text }), !!props.subText && (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontSize: size != 'sm' ? 14 : 12, marginLeft: 12 }, children: props.subText })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginBottom: -4, marginRight: -12 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { "aria-label": t('common:buttons.close'), hitSlop: 12, type: 'borderless', onPress: props.onClose, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.Xmark, size: 20, color: THEME.Text, style: { margin: 4 } }) }) })] }));
}
function PersonalInfoEditForm(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const STYLES = (0, Theme_1.useGlobalStyles)();
    const isDark = (0, ThemeContext_1.useIsDark)();
    const styles = react_1.default.useMemo(() => createStyles(THEME, isDark), [THEME, isDark]);
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const promise = react_1.default.useRef(null);
    const refreshPromise = react_1.default.useRef(null);
    const [status, setStatus] = react_1.default.useState("done");
    const [emailError, setEmailError] = react_1.default.useState(false);
    const [address1Error, setAddress1Error] = react_1.default.useState(false);
    const [cityError, setCityError] = react_1.default.useState(false);
    const [stateError, setStateError] = react_1.default.useState(false);
    const [zipError, setZipError] = react_1.default.useState(false);
    const [mailingZipError, setMailingZipError] = react_1.default.useState(false);
    const [w2ZipError, setW2ZipError] = react_1.default.useState(false);
    const [countyError, setCountyError] = react_1.default.useState(false);
    const [personalInfo, setPersonalInfo] = react_1.default.useState({
        firstName: "",
        lastName: "",
        nickname: "",
        email: "",
        phone: "",
        addressLine1: "",
        addressLine2: "",
        city: "",
        stateAbbr: "",
        zipCode: "",
        county: "",
        mailingAddressLine1: "",
        mailingAddressLine2: "",
        mailingCity: "",
        mailingStateAbbr: "",
        mailingZipCode: "",
        mailingCounty: "",
        mailingSameAsHome: null,
        w2SameAsHome: null,
        w2AddressLine1: "",
        w2AddressLine2: "",
        w2City: "",
        w2StateAbbr: "",
        w2ZipCode: "",
        w2County: "",
    });
    const originalInfoRef = react_1.default.useRef(null);
    const savedMailingRef = react_1.default.useRef(null);
    const savedW2Ref = react_1.default.useRef(null);
    const norm = (s) => (s ?? "").trim().toLowerCase();
    const key = (...parts) => parts.map((p) => norm(p ?? "")).join("|");
    const addrKey = (a1, a2, city, st, zip) => key(a1, a2, city, st, zip);
    const animateLayout = () => {
        if (react_native_1.Platform.OS !== "web") {
            react_native_1.LayoutAnimation.configureNext(react_native_1.LayoutAnimation.Presets.easeInEaseOut);
        }
    };
    const isCompact = size == 'sm';
    const toggleMailingSameAsHome = (value) => {
        animateLayout();
        props.onIsChanged();
        setPersonalInfo((prev) => {
            if (value) {
                savedMailingRef.current = {
                    mailingSameAsHome: prev.mailingSameAsHome,
                    mailingAddressLine1: prev.mailingAddressLine1,
                    mailingAddressLine2: prev.mailingAddressLine2,
                    mailingCity: prev.mailingCity,
                    mailingStateAbbr: prev.mailingStateAbbr,
                    mailingZipCode: prev.mailingZipCode,
                    mailingCounty: prev.mailingCounty,
                };
                return {
                    ...prev,
                    mailingSameAsHome: true,
                    mailingAddressLine1: "",
                    mailingAddressLine2: "",
                    mailingCity: "",
                    mailingStateAbbr: "",
                    mailingZipCode: "",
                    mailingCounty: "",
                };
            }
            const s = savedMailingRef.current ?? {};
            return {
                ...prev,
                mailingSameAsHome: false,
                mailingAddressLine1: s.mailingAddressLine1 ?? "",
                mailingAddressLine2: s.mailingAddressLine2 ?? "",
                mailingCity: s.mailingCity ?? "",
                mailingStateAbbr: s.mailingStateAbbr ?? "",
                mailingZipCode: s.mailingZipCode ?? "",
                mailingCounty: s.mailingCounty ?? "",
            };
        });
    };
    const toggleW2SameAsHome = (value) => {
        animateLayout();
        props.onIsChanged();
        setPersonalInfo((prev) => {
            if (value) {
                savedW2Ref.current = {
                    w2AddressLine1: prev.w2AddressLine1,
                    w2AddressLine2: prev.w2AddressLine2,
                    w2City: prev.w2City,
                    w2StateAbbr: prev.w2StateAbbr,
                    w2ZipCode: prev.w2ZipCode,
                    w2County: prev.w2County,
                };
                return {
                    ...prev,
                    w2SameAsHome: true,
                    w2AddressLine1: "",
                    w2AddressLine2: "",
                    w2City: "",
                    w2StateAbbr: "",
                    w2ZipCode: "",
                    w2County: "",
                };
            }
            const w2 = savedW2Ref.current ?? {};
            const m = savedMailingRef.current ?? {};
            return {
                ...prev,
                w2SameAsHome: false,
                w2AddressLine1: w2.w2AddressLine1 ?? "",
                w2AddressLine2: w2.w2AddressLine2 ?? "",
                w2City: w2.w2City ?? "",
                w2StateAbbr: w2.w2StateAbbr ?? "",
                w2ZipCode: w2.w2ZipCode ?? "",
                w2County: w2.w2County ?? "",
            };
        });
    };
    const save = react_1.default.useCallback(async () => {
        FirebaseAnalytics_1.default.LogEvent('feature_used', {
            'feature': 'Edit Personal Info',
            'client': userContext.client?.id,
            'employee': userContext.employee?.employeeId
        });
        promise.current?.cancel();
        setStatus("loading");
        // Enforce lowercase email
        personalInfo.email = personalInfo.email?.toLowerCase() ?? '';
        promise.current = (0, cancelable_promise_1.cancelable)(userContext
            .getToken()
            .then((t) => {
            const original = originalInfoRef.current;
            const payload = { ...personalInfo };
            const homeKey = addrKey(payload.addressLine1, payload.addressLine2, payload.city, payload.stateAbbr, payload.zipCode);
            const mailingKey = addrKey(payload.mailingAddressLine1, payload.mailingAddressLine2, payload.mailingCity, payload.mailingStateAbbr, payload.mailingZipCode);
            const w2Key = addrKey(payload.w2AddressLine1, payload.w2AddressLine2, payload.w2City, payload.w2StateAbbr, payload.w2ZipCode);
            const mailingFields = ["mailingAddressLine1", "mailingAddressLine2", "mailingCity", "mailingStateAbbr", "mailingZipCode"];
            const w2Fields = ["w2AddressLine1", "w2AddressLine2", "w2City", "w2StateAbbr", "w2ZipCode"];
            const mailingChanged = !original
                ? true
                : (payload.mailingSameAsHome !== original.mailingSameAsHome) ||
                    mailingFields.some((k) => (payload[k] ?? "") !== (original[k] ?? ""));
            const w2Changed = !original
                ? true
                : (payload.w2SameAsHome !== original.w2SameAsHome) ||
                    w2Fields.some((k) => (payload[k] ?? "") !== (original[k] ?? ""));
            if (payload.mailingSameAsHome === true || !norm(payload.mailingAddressLine1) || mailingKey === homeKey) {
                payload.mailingSameAsHome = true;
                payload.mailingAddressLine1 = "";
                payload.mailingAddressLine2 = "";
                payload.mailingCity = "";
                payload.mailingStateAbbr = "";
                payload.mailingZipCode = "";
                payload.mailingCounty = "";
            }
            else if (!mailingChanged) {
                payload.mailingAddressLine1 = null;
                payload.mailingAddressLine2 = null;
                payload.mailingCity = null;
                payload.mailingStateAbbr = null;
                payload.mailingZipCode = null;
                payload.mailingCounty = null;
            }
            if (payload.w2SameAsHome === true || w2Key === homeKey) {
                payload.w2SameAsHome = true;
                payload.w2AddressLine1 = "";
                payload.w2AddressLine2 = "";
                payload.w2City = "";
                payload.w2StateAbbr = "";
                payload.w2ZipCode = "";
                payload.w2County = "";
            }
            else if (!w2Changed) {
                payload.w2AddressLine1 = null;
                payload.w2AddressLine2 = null;
                payload.w2City = null;
                payload.w2StateAbbr = null;
                payload.w2ZipCode = null;
                payload.w2County = null;
            }
            else {
                if (!payload.w2AddressLine1 || /^\s*$/.test(payload.w2AddressLine1)) {
                    payload.w2AddressLine1 = "";
                    payload.w2AddressLine2 = "";
                    payload.w2City = "";
                    payload.w2StateAbbr = "";
                    payload.w2ZipCode = "";
                    payload.w2County = "";
                }
            }
            return MyProfile_1.default.updatePersonalInfo(t, payload);
        }).then((result) => {
            if (result.errorMessage) {
                if (result.errorMessage.includes("geo location")) {
                    react_native_1.DeviceEventEmitter.emit("event.showSnackbar", { type: "error", message: t('profile:messages.infoFail') + " " + t('profile:messages.zipState') });
                }
                else if (result.errorMessage.includes("city/county")) {
                    react_native_1.DeviceEventEmitter.emit("event.showSnackbar", { type: "error", message: t('profile:messages.infoFail') + " " + t('profile:messages.cityCounty') });
                }
                else if (result.errorMessage.includes("zip code")) {
                    react_native_1.DeviceEventEmitter.emit("event.showSnackbar", { type: "error", message: t('profile:messages.infoFail') + " " + t('profile:messages.badZip') });
                }
            }
            else {
                react_native_1.DeviceEventEmitter.emit("event.showSnackbar", { type: "success", message: t('profile:messages.infoSave') });
                react_native_1.DeviceEventEmitter.emit("event.personalInfoUpdate");
            }
        })
            .catch(() => {
            react_native_1.DeviceEventEmitter.emit("event.showSnackbar", { type: "error", message: t('profile:messages.infoFail') });
        })
            .finally(() => {
            props.onSaved();
        }));
    }, [personalInfo]);
    const close = () => {
        promise.current?.cancel();
        refreshPromise.current?.cancel();
        props.onCancel();
    };
    // Check if an input field has a valid value
    const hasErrors = (field, value) => {
        switch (field) {
            case "city":
                return !/^[A-Za-z\s]*$/.test(value) || !value || /^\s*$/.test(value) ? true : false;
            case "email":
                return !/^(\w|(\w+\+\w))+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/i.test(value) ? true : false;
            case "text":
                return (!value || /^\s*$/.test(value)) ? true : false;
            case "zipCode":
                return value?.length != 5 || value?.match(/^[0-9]+$/) == null ? true : false;
        }
    };
    // Check if form can be submitted
    const formHasErrors = () => {
        return emailError || address1Error || cityError || stateError || zipError || mailingZipError || w2ZipError || countyError;
    };
    const refresh = react_1.default.useCallback(() => {
        refreshPromise.current?.cancel();
        setStatus("loading");
        refreshPromise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then((token) => MyProfile_1.default.getPersonalInfo(token))).then((data) => {
            const homeKey = addrKey(data?.addressLine1, data?.addressLine2, data?.city, data?.stateAbbr, data?.zipCode);
            const mailingKey = addrKey(data?.mailingAddressLine1, data?.mailingAddressLine2, data?.mailingCity, data?.mailingStateAbbr, data?.mailingZipCode);
            const w2Key = addrKey(data?.w2AddressLine1, data?.w2AddressLine2, data?.w2City, data?.w2StateAbbr, data?.w2ZipCode);
            const inferredMailingSame = data?.mailingSameAsHome === true || !norm(data?.mailingAddressLine1) || mailingKey === homeKey;
            const inferredW2Same = data?.w2SameAsHome === true || (!!norm(data?.w2AddressLine1) && w2Key === homeKey) || (!norm(data?.w2AddressLine1) && inferredMailingSame);
            const next = {
                ...data,
                nickname: data?.nickname ?? "",
                email: data?.email?.toLowerCase() ?? "",
                mailingSameAsHome: inferredMailingSame,
                w2SameAsHome: inferredW2Same,
            };
            originalInfoRef.current = next;
            setPersonalInfo(next);
            setStatus("done");
            react_native_1.DeviceEventEmitter.emit("event.nameLoaded", { name: `${data.firstName} ${data.lastName}` });
        }).catch((e) => {
            setStatus("error");
        });
    }, []);
    react_1.default.useEffect(() => {
        const sub = react_native_1.DeviceEventEmitter.addListener("event.personalInfoUpdate", refresh);
        refresh();
        return () => {
            promise.current?.cancel();
            refreshPromise.current?.cancel();
            sub.remove();
        };
    }, [refresh]);
    react_1.default.useEffect(() => {
        if (react_native_1.Platform.OS === "android" && react_native_1.UIManager.setLayoutAnimationEnabledExperimental) {
            react_native_1.UIManager.setLayoutAnimationEnabledExperimental(true);
        }
    }, []);
    return ((status == "done" && ((0, jsx_runtime_1.jsxs)(FadeInView_1.default, { style: { flex: 1 }, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: size != 'sm' ? 'row' : 'column' }, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { marginRight: size != 'sm' ? 6 : 0, flex: size != 'sm' ? 1 : null, marginBottom: 12 }, children: [(0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { "aria-label": t('profile:labels.email'), dense: true, error: emailError, label: t('profile:labels.email') + ' *', mode: 'outlined', onChangeText: (value) => {
                                    props.onIsChanged();
                                    setPersonalInfo({
                                        ...personalInfo,
                                        email: value,
                                    });
                                    setEmailError(hasErrors("email", value));
                                }, style: STYLES.input, value: personalInfo.email, maxLength: 50 }), emailError && (0, jsx_runtime_1.jsx)(react_native_paper_1.HelperText, { type: "error", children: emailError ? t('common:messages.emailHelp') : '' })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginLeft: size != 'sm' ? 6 : 0, flex: size != 'sm' ? 1 : null, marginBottom: 12 }, children: (0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { "aria-label": t('common:labels.phone'), dense: true, inputMode: 'tel', label: t('common:labels.phone') + ' *', maxLength: 14, mode: 'outlined', style: STYLES.input, value: personalInfo.phone, render: (inputProps) => ((0, jsx_runtime_1.jsx)(react_native_mask_text_1.MaskedTextInput, { ...(() => { var { value, ...p } = inputProps; return p; })(), defaultValue: personalInfo.phone, mask: '(999) 999-9999', onChangeText: (formatted, extracted) => {
                                    props.onIsChanged();
                                    setPersonalInfo({
                                        ...personalInfo,
                                        phone: extracted,
                                    });
                                } })) }) })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginBottom: 8 }, children: (0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { "aria-label": t('profile:labels.nickname'), dense: true, label: t('profile:labels.nickname'), mode: 'outlined', onChangeText: (value) => {
                        props.onIsChanged();
                        setPersonalInfo({
                            ...personalInfo,
                            nickname: value,
                        });
                    }, style: STYLES.input, value: personalInfo.nickname, maxLength: 50 }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginBottom: 12 }, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.disclaimerContainer, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.InfoCircle, size: 14, color: THEME.TextMuted ?? THEME.Text, style: { marginRight: 8 } }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.disclaimerText, children: t('profile:text.preferredNameDisclaimer') })] }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.sectionHeader, children: (0, jsx_runtime_1.jsxs)(react_native_1.Text, { style: [styles.sectionTitle, { textAlign: "center" }], children: [" ", t("common:labels.homeAddress")] }) }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: size != 'sm' ? 'row' : 'column' }, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { marginRight: size != 'sm' ? 6 : 0, flex: size != 'sm' ? 1 : null, marginBottom: 12 }, children: [(0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { "aria-label": t('common:labels.address1'), dense: true, error: address1Error, label: t('common:labels.address1') + ' *', mode: 'outlined', onChangeText: (value) => {
                                    props.onIsChanged();
                                    setPersonalInfo({
                                        ...personalInfo,
                                        addressLine1: value,
                                    });
                                    setAddress1Error(hasErrors("text", value));
                                }, style: STYLES.input, value: personalInfo.addressLine1 }), address1Error && (0, jsx_runtime_1.jsx)(react_native_paper_1.HelperText, { type: "error", children: address1Error ? t('profile:messages.address1Req') : '' })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginLeft: size != 'sm' ? 6 : 0, flex: size != 'sm' ? 1 : null, marginBottom: 12 }, children: (0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { "aria-label": t('common:labels.address2'), dense: true, label: t('common:labels.address2'), mode: 'outlined', onChangeText: (value) => {
                                props.onIsChanged();
                                setPersonalInfo({
                                    ...personalInfo,
                                    addressLine2: value,
                                });
                            }, style: STYLES.input, value: personalInfo.addressLine2 }) })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: size != 'sm' ? 'row' : 'column' }, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { marginRight: size != 'sm' ? 6 : 0, flex: size != 'sm' ? 1 : null, marginBottom: 12 }, children: [(0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { "aria-label": t('common:labels.city'), dense: true, error: cityError, label: t('common:labels.city') + ' *', mode: 'outlined', onChangeText: (value) => {
                                    props.onIsChanged();
                                    setPersonalInfo({
                                        ...personalInfo,
                                        city: value,
                                    });
                                    setCityError(hasErrors("city", value));
                                }, style: STYLES.input, value: personalInfo.city }), cityError && (0, jsx_runtime_1.jsx)(react_native_paper_1.HelperText, { type: "error", children: cityError ? t('common:messages.cityHelp') : '' })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginLeft: size != 'sm' ? 6 : 0, flex: size != 'sm' ? 1 : null, marginBottom: 12 }, children: (0, jsx_runtime_1.jsx)(SearchableDropdown_1.default, { list: Helper_1.Helper.dropdownStateAbbr, label: t('common:labels.state') + ' *', setValue: (value) => {
                                props.onIsChanged();
                                setPersonalInfo({
                                    ...personalInfo,
                                    stateAbbr: value,
                                });
                                setStateError(hasErrors("text", value));
                            }, value: personalInfo.stateAbbr }) })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: size != 'sm' ? 'row' : 'column' }, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { marginRight: size != 'sm' ? 6 : 0, flex: size != 'sm' ? 1 : null, marginBottom: 12 }, children: [(0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { "aria-label": t('common:labels.zip'), dense: true, error: zipError, inputMode: 'numeric', label: t('common:labels.zip') + ' *', maxLength: 5, mode: 'outlined', onChangeText: (value) => {
                                    const digits = (value ?? "").replace(/\D/g, "").slice(0, 5);
                                    props.onIsChanged();
                                    setPersonalInfo({ ...personalInfo, zipCode: digits });
                                    setZipError(hasErrors("zipCode", digits));
                                }, style: STYLES.input, value: personalInfo.zipCode }), zipError && (0, jsx_runtime_1.jsx)(react_native_paper_1.HelperText, { type: "error", children: zipError ? t('common:messages.zipHelp') : '' })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { marginLeft: size != 'sm' ? 6 : 0, flex: size != 'sm' ? 1 : null, marginBottom: 12 }, children: [(0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { "aria-label": t('common:labels.county'), dense: true, error: countyError, label: t('common:labels.county') + ' *', mode: 'outlined', onChangeText: (value) => {
                                    props.onIsChanged();
                                    setPersonalInfo({
                                        ...personalInfo,
                                        county: value,
                                    });
                                    setCountyError(hasErrors("city", value) || hasErrors("text", value));
                                }, style: STYLES.input, value: personalInfo.county }), countyError && (0, jsx_runtime_1.jsx)(react_native_paper_1.HelperText, { type: "error", children: countyError ? t('common:messages.countyHelp') : '' })] })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.sectionHeader, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: [styles.sectionLeft, isCompact && styles.sectionLeftCompact], children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.sectionTitle, children: t("common:labels.mailingAddress") }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.sectionHint, children: t("common:text.mailingBlankUsesHome") })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.sameAsHomeAbsolute, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.sameAsHomeText, children: t("common:labels.sameAsHome") }), (0, jsx_runtime_1.jsx)(react_native_paper_1.Switch, { value: personalInfo.mailingSameAsHome === true, onValueChange: toggleMailingSameAsHome, color: THEME.Primary, style: styles.sameAsHomeSwitch })] })] }), (0, jsx_runtime_1.jsx)(Collapsible, { collapsed: personalInfo.mailingSameAsHome === true, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: size != 'sm' ? "row" : "column" }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: {
                                        marginRight: size != 'sm' ? 6 : 0,
                                        flex: size != 'sm' ? 1 : null,
                                        marginBottom: 12,
                                    }, children: (0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { "aria-label": t("common:labels.address1"), activeOutlineColor: THEME.Primary, dense: true, error: address1Error, label: t("common:labels.address1"), mode: "outlined", onChangeText: (value) => {
                                            props.onIsChanged();
                                            setPersonalInfo({ ...personalInfo, mailingAddressLine1: value });
                                        }, style: STYLES.input, value: personalInfo.mailingAddressLine1 }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: {
                                        marginLeft: size != 'sm' ? 6 : 0,
                                        flex: size != 'sm' ? 1 : null,
                                        marginBottom: 12,
                                    }, children: (0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { "aria-label": t("common:labels.address2"), activeOutlineColor: THEME.Primary, dense: true, label: t("common:labels.address2"), mode: "outlined", onChangeText: (value) => {
                                            props.onIsChanged();
                                            setPersonalInfo({ ...personalInfo, mailingAddressLine2: value });
                                        }, style: STYLES.input, value: personalInfo.mailingAddressLine2 }) })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: size != 'sm' ? "row" : "column" }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: {
                                        marginRight: size != 'sm' ? 6 : 0,
                                        flex: size != 'sm' ? 1 : null,
                                        marginBottom: 12,
                                    }, children: (0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { "aria-label": t("common:labels.city"), activeOutlineColor: THEME.Primary, dense: true, error: cityError, label: t("common:labels.city"), mode: "outlined", onChangeText: (value) => {
                                            props.onIsChanged();
                                            setPersonalInfo({ ...personalInfo, mailingCity: value });
                                        }, style: STYLES.input, value: personalInfo.mailingCity }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: {
                                        marginLeft: size != 'sm' ? 6 : 0,
                                        flex: size != 'sm' ? 1 : null,
                                        marginBottom: 12,
                                    }, children: (0, jsx_runtime_1.jsx)(SearchableDropdown_1.default, { list: Helper_1.Helper.dropdownStateAbbr, label: t("common:labels.state"), setValue: (value) => {
                                            props.onIsChanged();
                                            setPersonalInfo({ ...personalInfo, mailingStateAbbr: value });
                                        }, value: personalInfo.mailingStateAbbr }) })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.zipFullRow, children: [(0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { "aria-label": t("common:labels.zip"), activeOutlineColor: THEME.Primary, dense: true, error: mailingZipError, inputMode: "numeric", label: t("common:labels.zip"), maxLength: 5, mode: "outlined", onChangeText: (value) => {
                                        const digits = (value ?? "").replace(/\D/g, "").slice(0, 5);
                                        props.onIsChanged();
                                        setPersonalInfo({ ...personalInfo, mailingZipCode: digits });
                                        setMailingZipError(digits.length > 0 ? hasErrors("zipCode", digits) : false);
                                    }, style: STYLES.input, value: personalInfo.mailingZipCode }), mailingZipError && (0, jsx_runtime_1.jsx)(react_native_paper_1.HelperText, { type: "error", children: t("common:messages.zipHelp") })] })] }) }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.sectionHeader, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: [styles.sectionLeft, isCompact && styles.sectionLeftCompact], children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.sectionTitle, children: t("common:labels.w2Address") }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.sectionHint, children: t("common:text.w2BlankUsesMailing") })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.sameAsHomeAbsolute, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.sameAsHomeText, children: t("common:labels.sameAsHome") }), (0, jsx_runtime_1.jsx)(react_native_paper_1.Switch, { value: personalInfo.w2SameAsHome === true, onValueChange: toggleW2SameAsHome, color: THEME.Primary, style: styles.sameAsHomeSwitch })] })] }), (0, jsx_runtime_1.jsx)(Collapsible, { collapsed: personalInfo.w2SameAsHome === true, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: size != 'sm' ? "row" : "column" }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: {
                                        marginRight: size != 'sm' ? 6 : 0,
                                        flex: size != 'sm' ? 1 : null,
                                        marginBottom: 12,
                                    }, children: (0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { "aria-label": t("common:labels.address1"), activeOutlineColor: THEME.Primary, dense: true, label: t("common:labels.address1"), mode: "outlined", onChangeText: (value) => {
                                            props.onIsChanged();
                                            setPersonalInfo({ ...personalInfo, w2AddressLine1: value });
                                        }, style: STYLES.input, value: personalInfo.w2AddressLine1 }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: {
                                        marginLeft: size != 'sm' ? 6 : 0,
                                        flex: size != 'sm' ? 1 : null,
                                        marginBottom: 12,
                                    }, children: (0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { "aria-label": t("common:labels.address2"), activeOutlineColor: THEME.Primary, dense: true, label: t("common:labels.address2"), mode: "outlined", onChangeText: (value) => {
                                            props.onIsChanged();
                                            setPersonalInfo({ ...personalInfo, w2AddressLine2: value });
                                        }, style: STYLES.input, value: personalInfo.w2AddressLine2 }) })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: size != 'sm' ? "row" : "column" }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: {
                                        marginRight: size != 'sm' ? 6 : 0,
                                        flex: size != 'sm' ? 1 : null,
                                        marginBottom: 12,
                                    }, children: (0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { "aria-label": t("common:labels.city"), activeOutlineColor: THEME.Primary, dense: true, label: t("common:labels.city"), mode: "outlined", onChangeText: (value) => {
                                            props.onIsChanged();
                                            setPersonalInfo({ ...personalInfo, w2City: value });
                                        }, style: STYLES.input, value: personalInfo.w2City }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: {
                                        marginLeft: size != 'sm' ? 6 : 0,
                                        flex: size != 'sm' ? 1 : null,
                                        marginBottom: 12,
                                    }, children: (0, jsx_runtime_1.jsx)(SearchableDropdown_1.default, { list: Helper_1.Helper.dropdownStateAbbr, label: t("common:labels.state"), setValue: (value) => {
                                            props.onIsChanged();
                                            setPersonalInfo({ ...personalInfo, w2StateAbbr: value });
                                        }, value: personalInfo.w2StateAbbr }) })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.zipFullRow, children: [(0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { "aria-label": t("common:labels.zip"), activeOutlineColor: THEME.Primary, dense: true, inputMode: "numeric", label: t("common:labels.zip"), maxLength: 5, mode: "outlined", error: w2ZipError, onChangeText: (value) => {
                                        const digits = (value ?? "").replace(/\D/g, "").slice(0, 5);
                                        props.onIsChanged();
                                        setPersonalInfo({ ...personalInfo, w2ZipCode: digits });
                                        setW2ZipError(digits.length > 0 ? hasErrors("zipCode", digits) : false);
                                    }, style: STYLES.input, value: personalInfo.w2ZipCode }), w2ZipError && ((0, jsx_runtime_1.jsx)(react_native_paper_1.HelperText, { type: "error", children: t("common:messages.zipHelp") }))] })] }) }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: "row", marginHorizontal: -6, marginTop: 6 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, marginHorizontal: 6 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { type: "outline", text: t('common:buttons.cancel'), onPress: close }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, marginHorizontal: 6 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { disabled: formHasErrors(), text: t('common:buttons.save'), onPress: save }) })] })] }))) || (0, jsx_runtime_1.jsx)(Loading_1.default, { retryable: true, loading: status == "loading" }));
}
function PersonalInfoEdit(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const [name, setName] = react_1.default.useState("");
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const [isChanged, setIsChanged] = react_1.default.useState(false);
    const [isConfirming, setIsConfirming] = react_1.default.useState(false);
    const onClose = () => {
        if (isChanged) {
            setIsConfirming(true);
        }
        else {
            props.navigation.goBack();
        }
    };
    react_1.default.useEffect(() => {
        const sub = react_native_1.DeviceEventEmitter.addListener("event.nameLoaded", (eventData) => onNameLoaded(eventData));
        return () => sub.remove();
    }, []);
    const onNameLoaded = (result) => {
        setName(result?.name ?? "");
    };
    return ((0, jsx_runtime_1.jsxs)(ModalWrapper_1.default, { navigation: props.navigation, needsConfirmation: isChanged, onConfirmation: () => setIsConfirming(true), children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { paddingHorizontal: 12, paddingTop: 8, paddingBottom: 2 }, children: (0, jsx_runtime_1.jsx)(PersonalInfoHeader, { text: t('profile:text.persInfo'), subText: name, onClose: onClose }) }), (0, jsx_runtime_1.jsxs)(react_native_1.ScrollView, { contentContainerStyle: { paddingHorizontal: 12, paddingBottom: 12 }, keyboardShouldPersistTaps: "handled", children: [isConfirming &&
                        (0, jsx_runtime_1.jsxs)(react_native_1.View, { children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { marginBottom: 12, backgroundColor: THEME.UltraLightGray, borderRadius: 4, flexDirection: 'row' }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { width: 6, borderBottomLeftRadius: 4, borderTopLeftRadius: 4, backgroundColor: THEME.Red } }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { padding: 12, flex: 1 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontSize: size != 'sm' ? 14 : 12, fontWeight: '500', paddingVertical: 1 }, children: t('common:text.sure') }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontSize: size != 'sm' ? 14 : 12, paddingVertical: 1 }, children: t('common:text.sureDescription') })] })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', marginTop: 6, marginBottom: size != 'sm' ? 0 : 12, marginHorizontal: -6 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, marginHorizontal: 6 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { type: 'outline', text: t('common:buttons.back'), onPress: () => setIsConfirming(false) }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, marginHorizontal: 6 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { text: t('common:buttons.discard'), onPress: () => props.navigation.goBack() }) })] })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { display: isConfirming ? 'none' : undefined }, children: (0, jsx_runtime_1.jsx)(PersonalInfoEditForm, { onCancel: onClose, onSaved: props.onSave ?? props.navigation.goBack, onIsChanged: () => setIsChanged(true) }) })] })] }));
}
